/* Firebase configuration */
export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyCmt9Tbjw4NwQjs2Gk4ACCLwhGf_SxaQJQ",
  authDomain: "livequiz-8bb02.firebaseapp.com",
  databaseURL: "https://livequiz-8bb02.firebaseio.com",
  projectId: "livequiz-8bb02",
  storageBucket: "",
  messagingSenderId: "554690598898"
};


// WEBPACK FOOTER //
// ./src/_config/firebase.config.ts